import template from './index.html'
import controller from './controller'

export const vsName = 'machinesContractMainGrid'
export const vsNgType = 'directive'

MachineContractsGridDirective.$inject = []
export function MachineContractsGridDirective() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {},
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true
  }
}
